import { db } from '@/firebase'

const productRef = db.collection('products')

export default {
  state: {
    isProductBtnLoading: false
  },
  mutations: {
    toggleProductBtnLoading (state, payload) {
      if (payload === undefined || payload === null) {
        state.isProductBtnLoading = !state.isProductBtnLoading
      } else {
        state.isProductBtnLoading = payload
      }
    }
  },
  actions: {
    createProduct ({ commit }, payload) {
      return productRef.add(payload)
    },
    getProducts ({ commit }) {
      return productRef.get()
    },
    getProductDetail ({ commit }, id) {
      return productRef.doc(id).get()
    },
    updateProductDetail ({ commit }, { id, ...payload }) {
      return productRef.doc(id).set(payload, { merge: true })
    },
    deleteProduct ({ commit }, id) {
      return productRef.doc(id).delete()
    }
  },
  getters: {
    isProductBtnLoading: (state) => state.isProductBtnLoading
  }
}
